import { render, staticRenderFns } from "./AboutComponent.vue?vue&type=template&id=22386aff&"
import script from "./AboutComponent.vue?vue&type=script&lang=js&"
export * from "./AboutComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports